<template>
  <div class="menu">
    <div
      class="header"
      :class="{ 'center-logo': userIsLogged }"
    >
      <button
        v-if="!currentPage('Home')"
        class="first-line__goBack"
        @click.prevent="backToComponent()"
      >
        <icon
          icon="ArrowPrev"
          class="arrow-prev"
        />
      </button>
      <div
        class="first-line"
        :class="{ 'first-line-isHome': currentPage('Home') }"
      >
        <router-link
          :to="{ name: 'Home' }"
          class="first-line__homeLink"
          @click="redirectToHome()"
        >
          <img
            :src="require(`@/assets/theme/${realm}/icons/logo-cidade.svg`)"
            alt="Imagem da prefeitura de Sua Cidade"
          >
        </router-link>
        <div class="header-options">
          <div class="header-options__item">
            <a
              @click="$emit('show-modal')"
            >
              <router-link
                :class="{ 'header-options__item-current': currentPage('NewReclamation') }"
                :to="{ name: 'NewReclamation' }"
              >
                Reclamação
              </router-link>
            </a>
          </div>
          <div class="header-options__item">
            <a
              @click="$emit('show-modal')"
            >
              <router-link
                :class="{ 'header-options__item-current': currentPage('MyComplaints') }"
                :to="{ path: '/minhas-reclamacoes' }"
              >
                Minhas reclamações
              </router-link>
            </a>
          </div>
          <div class="header-options__item">
            <router-link
              :class="{ 'header-options__item-current': currentPage('FAQ') }"
              :to="{ name: 'FAQ' }"
            >
              Ajuda
            </router-link>
          </div>
        </div>
      </div>
      <div
        v-if="userIsLogged"
        class="header-user"
        @click="toggleMenu()"
      >
        <div
          :style="{ 'display': currentPage('Home') ? 'block' : '' }"
          class="header-user__textBox"
        >
          <div
            class="header-user__name"
          >
            Olá, {{ firstName }}
          </div>
        </div>
        <img
          v-if="userData.avatar"
          :src="userData.avatar"
          :alt="userData.nome"
          class="header-user__avatar"
        >
        <AvatarPlaceholder
          v-else
          :username="firstName"
          :size="35"
        />
      </div>
      <div
        v-else
        class="first-line__notLoggedDiv"
      >
        <ButtonComponent
          class="register"
          text="CADASTRAR"
          btn-style="secondary"
          @click.native="userRegister()"
        />
        <ButtonComponent
          class="login"
          text="ENTRAR"
          @click.native="userLogin()"
        />
      </div>
      <div
        class="menu-open"
        :class="{ 'menu-open--visible': menuState }"
      >
        <a
          :href="minhaContaUrl"
          class="menu-open__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="menu-open__link__text">
            Minha Conta
          </span>
          <icon
            class="menu-open__link__icon"
            icon="ExternalLink"
          />
        </a>
        <router-link
          :to="{ name: 'MyComplaints' }"
          class="menu-open__link"
          @click.native="closeMenu"
        >
          <span class="menu-open__link__text">
            Minhas Reclamações
          </span>
        </router-link>
        <a
          href="#"
          class="menu-open__link"
          @click.prevent="logout()"
        >
          <span class="menu-open__link__text">
            Sair
          </span>
        </a>
      </div>
    </div>
    <BottomNavigation
      :current-view="currentView"
      @show-modal="$emit('show-modal')"
    />
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex';
import icon from '@/components/base/svg/SVG.vue';
import BottomNavigation from '@/components/common/BottomNavigation.vue';
import ButtonComponent from '../common/ButtonComponent.vue';
const realmTheme = process.env.VUE_APP_THEME_REALM ?? process.env.VUE_APP_KEYCLOAK_REALM;

export default {
  name: 'FirstLine',
  components: {
    icon,
    BottomNavigation,
    ButtonComponent
  },

  props: {
    currentView: {
      type: String,
      required: true
    }
  },

  data() {
    const realm = realmTheme  === 'Uppersoft'  ?  'upcities' : realmTheme;

    return {
      menuState: false,
      realm
    };
  },

  computed: {
    ...mapGetters([
      'userIsLogged',
      'backToWhere',
      'userData'
    ]),

    firstName() {
      const splitedName = this.userData.name ? this.userData.name.split(' ') : null;

      return splitedName !== null ? splitedName[0] : '';
    },

    minhaContaUrl(){
      return process.env.VUE_APP_MINHACONTA_ROUTE;
    }
  },

  mounted() {
    window.addEventListener('click', this.eventCloseMenu);
  },

  beforeDestroy () {
    document.removeEventListener('click', this.eventCloseMenu);
  },

  methods: {
    ...mapActions([
      'userLogout',
      'registerKeycloak',
      'loginKeycloak',
      'routeStepChange'
    ]),

     async logout(){
      this.closeMenu();
      await this.$router.replace({ name: 'Home', query: {} }).catch(() => {});
      await this.userLogout();
    },

    async userRegister(){
      try {
        await this.registerKeycloak();
      } catch (error) {
        await this.$router.replace({ name: 'Error' }).catch(() => {});
      }
    },

    async userLogin(){
      try {
        await this.loginKeycloak();
      } catch (error) {
        await this.$router.replace({ name: 'Error' }).catch(() => {});
      }
    },

    backToComponent() {
      this.$root.$refs.Footer.closeMobileMenu();
      if(this.$route.name === 'ServiceAppointment')
        this.routeStepChange(true);
      else
        return this.$router.go(-1);
    },

    currentPage(page){
      return this.currentView === page;
    },

    toggleMenu() {
        this.menuState = !this.menuState;
    },

    closeMenu() {
      this.menuState = false;
    },

    eventCloseMenu(e) {
      if (!document.querySelector('.menu-open')?.contains(e.target) &&
        !document.querySelector('.header-user')?.contains(e.target)){
        this.closeMenu();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 0;
    position: relative;
    height: 70px;

    @include screen (phone-up) {
      justify-content: space-between;
    }

    &-options {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 2rem;

      @include screen(phone-only) {
        display: none;
      }

      @include screen(tablet-big-up) {
        margin-left: 5rem;
      }

      &__item {
        margin-right: 1rem;
        font-size: $text-xs;

        a {
          padding: 1.5rem 0;

          &:hover:not(.header-options__item-current) {
            color: $primary;
          }
        }

        &-current {
          color: $gray-dark;
          font-weight: $font-bold;
          border-bottom: none;

          @include screen(tablet-big-up) {
            border-bottom: 2px solid $text-dark;
          }
        }

        @include screen (tablet-big-up) {
          margin-right: 3rem;
          font-size: $text-sm;
        }
      }
    }

    &-user {
      margin-right: 2%;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;

      @include screen (phone-only) {
        display: none;
      }

      @include screen(phone-up) {
        margin-right: 4%;
      }

      @include screen(tablet-big-up) {
        margin-right: 8%;
      }

      &__avatar {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        object-fit: cover;
      }

      &__textBox {
        display: none;
        text-align: right;

        @include screen (phone-up) {
          display: block;
        }
      }

      &__name {
        margin-right: 0.5rem;
        font-size: $text-xs;

        @include screen (tablet-big-up) {
          font-size: $text-sm;
        }
      }

      &__unity {
        margin-right: 0.5rem;
        font-size: $text-xs;
        color: $unity-color-label;
        font-weight: bold;
      }
    }

    .menu-open {
      display: none;
      flex-direction: column;
      box-shadow: 0 4px 8px 0 #00000014;
      background-color: white;
      transition: all 0.3s ease-in;
      z-index: 999;
      position: absolute;
      right: 7%;
      top: 6rem;
      padding: 0 1.5rem;
      border-radius: $radius-normal;
      transform-origin: 100% 0%;
      transform: scaleY(0);

      @include screen(phone-up) {
        display: flex;
      }

      &:hover {
        box-shadow: 0 6px 12px 0 $gray-400;
        transition: all 0.3s ease-out;
      }

      &__link {
        display: flex;
        justify-content: space-between;
        padding: 1rem 0;
        color: $gray-400;
        border-bottom: 0.5px solid $gray-200;

        &:hover {
          color: $primary;
        }

        &:last-child {
          border-bottom: none;
        }

        &__icon {
          color: $gray-200;
        }
      }

      &--visible {
        transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        z-index: 999;
        transform-origin: 100% 0%;
        transform: scaleY(1);

        &::before {
          @include screen(tablet-down) {
            display: flex;
            background: var(--black);
          }
        }
      }
    }
  }

  .first-line {
    padding-left: 4%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.4rem;
    margin-top: 0.4rem;

    @include screen (phone-only) {
      padding-left: 0;
    }

    &__goBack {
      display: none;
      margin-right: 1rem;
      left: 0;
      position: absolute;

      .arrow-prev {
        color: $primary;
      }

      @include screen(phone-only) {
        display: flex;
      }
    }

    &__homeLink {
      cursor: pointer;

      img {
        max-width: 120px;
      }
    }

    &__notLoggedDiv {
      display: flex;
      justify-content: space-between;
      font-weight: $font-bold;
      padding-right: 4%;

      @include screen (tablet-big-up) {
        padding-right: 8%;
        display: grid;
        grid-template-columns: 1fr 1fr;
      }

      @include screen (phone-only) {
        padding-right: 0;
      }

      .login {
        display: none;
        margin-left: 0.5rem;
        margin-right: 0.5rem;

        @include screen (tablet-up) {
          display: flex;
        }
      }

      .register {
        display: none;

        @include screen (tablet-up) {
          display: flex;
          margin-left: 0.5rem;
          margin-right: 0.5rem;
        }
      }
    }

    @include screen (phone-only) {
      padding: 0;
    }

    @include screen (tablet-big-up) {
      padding-left: 8%;
    }
  }

  .center-logo {
    @include screen(phone-only) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      align-content: center;
    }

    .first-line {
      grid-column: 2/3;
    }
  }

  .disabled {
    font-weight: $font-bold;
    pointer-events: none;
    cursor: default;

    .arrow-prev {
      color: $gray-disabled-theme;
    }
  }
</style>
